import {
  Routes,
  Route,
  RoutesProps,
} from "react-router-dom";

import React, { Suspense } from "react";
import ProtectedRoute from "./ProtectedRoute";
import Main from "../components/Main";
import SportListingMain from "../components/ManageSport/SportListingMain";
import SponsorshipListingMain from "../components/ManageSponsorship/SponsorShipListingMain";

const Navigation = () => {

  interface ProtectedRouteProps extends RoutesProps {
    authenticationPath: string;
  }
  const defaultProtectedRouteProps: Omit<ProtectedRouteProps, "outlet"> = {
    authenticationPath: "/login",
  };

  const Login = React.lazy(() => import("../components/Login/Login"));
  const ForgotPassword = React.lazy(() => import("../components/Login/ForgotPassword"));
  const Otp = React.lazy(() => import("../components/Login/Otp"));
  const CratePassword = React.lazy(() => import("../components/Login/CratePassword"));

  const Dashboard = React.lazy(() => import("../components/Dashboard/Dashboard"));

  const UserListing = React.lazy(() => import("../components/ManageAdminUser/users"));
  const AddUser = React.lazy(() => import("../components/ManageAdminUser/AddEditUser"));

  const ProfileSetting = React.lazy(() => import("../components/Header/profileSetting"));

  const ManageSportList = React.lazy(() => import("../components/ManageSport/SportListing"));
  const AddEditSport = React.lazy(() => import("../components/ManageSport/AddEditSport"));

  const SponsorshipList = React.lazy(() => import("../components/ManageSponsorship/SponsorshipListing"));
  const AddEditSponsorship = React.lazy(() => import("../components/ManageSponsorship/AddEditSponorship"));

  const LeagueListing = React.lazy(() => import("../components/ManageLeague/LeagueListing"));

  const FixtureList = React.lazy(() => import("../components/ManageFixture/FixtureListing"));
  const FixtureInfo = React.lazy(() => import("../components/ManageFixture/FixtureInfo"));

  return (
    <>
      <div id="main-wraper">
        <Routes>
          <Route path="/login" element={<Suspense fallback={<></>}> <Login /> </Suspense>} />
          <Route path="/forgot-password" element={<Suspense fallback={<></>}> <ForgotPassword /> </Suspense>} />
          <Route path="/otp" element={<Suspense fallback={<></>}> <Otp /> </Suspense>} />
          <Route path="/crate-password" element={<Suspense fallback={<></>}> <CratePassword /> </Suspense>} />

          <Route path="/" element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<Main />} />} >
            <Route path="/dashboard" element={<Suspense fallback={<></>}> <Dashboard /> </Suspense>} />

            <Route path="/manage-admin-users" element={<Suspense fallback={<></>}> <UserListing /> </Suspense>} />
            <Route path="/add-user" element={<Suspense fallback={<></>}> <AddUser /> </Suspense>} />
            <Route path="/edit-user/:id" element={<Suspense fallback={<></>}> <AddUser /> </Suspense>} />

            <Route path="/profile-setting" element={<Suspense fallback={<></>}><ProfileSetting /></Suspense>} />

            <Route path="/manage-sponsorship" element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<SponsorshipListingMain />} />} >
              <Route path="" element={<Suspense fallback={<></>}><SponsorshipList /></Suspense>} />
              <Route path="add-sponsorship" element={<Suspense fallback={<></>}><AddEditSponsorship /></Suspense>} />
              <Route path="edit-sponsorship/:id" element={<Suspense fallback={<></>}><AddEditSponsorship /></Suspense>} />
            </Route>

            <Route path="/manage-sport" element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<SportListingMain />} />}  >
              <Route path="" element={<Suspense fallback={<></>}><ManageSportList /></Suspense>} />
              <Route path="add-sport" element={<Suspense fallback={<></>}><AddEditSport /></Suspense>} />
              <Route path="edit-sport/:id" element={<Suspense fallback={<></>}><AddEditSport /></Suspense>} />
            </Route>

            <Route path="/manage-league" element={<Suspense fallback={<></>}><LeagueListing /></Suspense>} />

            <Route path="/manage-fixture" element={<Suspense fallback={<></>}><FixtureList /></Suspense>} />
            <Route path="/view-fixture/:id" element={<Suspense fallback={<></>}><FixtureInfo /></Suspense>} />
          </Route>
        </Routes >
      </div >
    </>
  );
};

export default Navigation;
